import { push } from 'connected-react-router';
import API from '../helpers/api';

export function logout() {
	return async dispatch => {
		const res = await API.auth.logout();
		localStorage.removeItem('cso_app');
		if (res.meta.code !== 200) {
			return;
		}
		if (['production'].indexOf(process.env.NODE_ENV) !== -1) {
			window.location.href = res.data.logout_url;
			return;
		}
		dispatch(push('/login'));
	};
}
